import _ from 'lodash';

import {
  SYSTEM_HEALTH_CHANGE_ALERT_CATEGORY,
  SYSTEM_HEALTH_CHANGE_ALERT_TYPE,
  SYSTEM_HEALTH_CHANGE_TABLE_OPTION,
  SYSTEM_HEALTH_CHANGE_VALUE,
  SYSTEM_HEALTH_CHANGE_VALUES,
  SYSTEM_HEALTH_RESET_SYSTEM_HEALTH,
  SYSTEM_HEALTH_RESET_SYSTEM_HEALTH_LOADER,
  SYSTEM_HEALTH_SET_EXPANDABLE_ROW,
  SYSTEM_HEALTH_SET_EXPANDABLE_ROW_AGAIN,
  SYSTEM_HEALTH_SET_HEADER,
  SYSTEM_HEALTH_SET_HEADER_FILTER,
  SYSTEM_HEALTH_SET_SYSTEM_HEALTH,
  SYSTEM_HEALTH_SET_SYSTEM_HEALTH_AGAIN,
} from '@shared/store/constants/mutationTypes';

import filterLife from '@shared/lib/general/filterLife';
import apiClient from '@shared/lib/general/apiClient';
import initialState from './systemHealthInitialState';

const actions = {
  changeSystemHealthValues({ commit }, changes) {
    commit({
      type: SYSTEM_HEALTH_CHANGE_VALUES,
      changes,
    });
  },
  setHeaderFilter({ commit }, payload) {
    const { header, filter } = payload;

    commit({
      type: SYSTEM_HEALTH_SET_HEADER_FILTER,
      header,
      filter,
    });
  },
  setSystemHealthHeaders({ commit, rootState }) {
    const {
      admin: {
        adminFilter: { corpId },
      },
    } = rootState;

    const { systemHealthTableHeaders } = initialState();

    let newHeaders;
    if (corpId === 1) {
      newHeaders = systemHealthTableHeaders;
    } else {
      newHeaders = systemHealthTableHeaders.filter(
        (h) => h.text !== 'SERIAL NUMBER' && h.text !== 'CHANNEL',
      );
    }

    commit({
      type: SYSTEM_HEALTH_SET_HEADER,
      newHeaders,
    });
  },
  changeHomeValue({ commit }, payload) {
    const { field, value } = payload;

    commit({
      type: SYSTEM_HEALTH_CHANGE_VALUE,
      field,
      value,
    });
  },
  changeSHTableOption({ commit }, payload) {
    const { field, value } = payload;
    commit({
      type: SYSTEM_HEALTH_CHANGE_TABLE_OPTION,
      field,
      value,
    });
  },
  changeSHTableAlertType({ commit, state }, payload) {
    const { activeCorpFilter, iHaveEverything, activeProfileTab } = state;

    const { completedProfile, incompletedProfile } = iHaveEverything.get('all');

    let allSystemHealth;
    let newCompletedProfile;
    let newIncompletedProfile;

    let { filterByCorp, profileTab } = payload;

    const {
      healthTab, type, filter, value,
    } = payload;

    const newAlertsCategory = _.cloneDeep(state.alertsCategory);
    if (type && type === 'category') {
      newAlertsCategory[filter].active = value;

      commit({
        type: SYSTEM_HEALTH_CHANGE_ALERT_CATEGORY,
        newAlertsCategory,
      });
    }

    let tableData = [];
    let activeCorpSystemHealth = [];

    if (!filterByCorp) {
      filterByCorp = activeCorpFilter;
    }
    if (!profileTab) {
      profileTab = activeProfileTab;
    }

    if (profileTab === 'complete') {
      allSystemHealth = completedProfile.slice();
    } else {
      allSystemHealth = incompletedProfile.slice();
    }

    if (filterByCorp === 'all') {
      activeCorpSystemHealth = allSystemHealth.slice();
      newCompletedProfile = completedProfile.slice();
      newIncompletedProfile = incompletedProfile.slice();
    } else {
      activeCorpSystemHealth = allSystemHealth.filter(
        (h) => h.customer.corporationId === filterByCorp,
      );
      newCompletedProfile = completedProfile.filter((h) => (
        h.customer.corporationId === filterByCorp
      ));
      newIncompletedProfile = incompletedProfile.filter(
        (h) => h.customer.corporationId === filterByCorp,
      );
    }

    // Reset Count every time
    newAlertsCategory.performance.count = 0;
    newAlertsCategory.leak.count = 0;
    newAlertsCategory.filter.count = 0;
    newAlertsCategory.noAlerts.count = 0;

    activeCorpSystemHealth.forEach((d) => {
      const { alerts } = d;

      let hasPerformance = false;
      let hasFilter = false;
      let hasLeak = false;

      alerts.forEach((alert) => {
        const { category } = alert;
        if (category === 'Performance') {
          hasPerformance = true;
        }
        if (category === 'Filter') {
          hasFilter = true;
        }
        if (category === 'Leak') {
          hasLeak = true;
        }
      });

      if (hasFilter) {
        newAlertsCategory.filter.count += 1;
        if (newAlertsCategory.filter.active) {
          tableData.push(d);
        }
      }
      if (hasPerformance) {
        newAlertsCategory.performance.count += 1;
        if (newAlertsCategory.performance.active) {
          tableData.push(d);
        }
      }
      if (hasLeak) {
        newAlertsCategory.leak.count += 1;
        if (newAlertsCategory.leak.active) {
          tableData.push(d);
        }
      }

      if (alerts.length === 0) {
        if (newAlertsCategory.noAlerts.active) {
          tableData.push(d);
        }
        newAlertsCategory.noAlerts.count += 1;
      }
    });

    tableData = _.uniqBy(tableData, 'key');

    if (healthTab === 'severe') {
      tableData = tableData.filter((t) => t.systemHealthRating === 'Severe');
    } else if (healthTab === 'mild') {
      tableData = tableData.filter((t) => t.systemHealthRating === 'Mild');
    } else if (healthTab === 'normal') {
      tableData = tableData.filter((t) => t.systemHealthRating === 'Normal');
    }

    commit({
      type: SYSTEM_HEALTH_CHANGE_ALERT_TYPE,
      tableData,
      activeCorpFilter: filterByCorp,
      activeHealthTab: healthTab,
      activeProfileTab: profileTab,
      activeCorpSystemHealth,
      newCompletedProfile,
      newIncompletedProfile,
      alertsCategory: newAlertsCategory,
    });
  },
  async getSystemHealth({
    commit, dispatch, rootState,
  }) {
    const {
      admin: {
        adminFilter: {
          corpId,
        },
      },
    } = rootState;

    dispatch('changeSystemHealthValues', [{
      field: 'loading',
      value: true,
    }, {
      field: 'allSystemHealth',
      value: [],
    }, {
      field: 'tableData',
      value: [],
    }, {
      field: 'iHaveEverything',
      value: new Map(),
    }, {
      field: 'alertCategory',
      value: {
        performance: {
          count: 0,
          label: 'Performance',
          value: 'performance',
          nonSmacAdmin: true,
          active: true,
        },
        leak: {
          count: 0,
          label: 'Leak',
          value: 'leak',
          nonSmacAdmin: true,
          active: true,
        },
        filter: {
          count: 0,
          label: 'Filter',
          value: 'filter',
          active: true,
        },
        noAlerts: {
          count: 0,
          label: 'No Alerts',
          value: 'noAlerts',
          nonSmacAdmin: true,
          active: true,
        },
      },
    }]);

    const iHaveEverything = new Map();

    const cId = corpId;

    let url = `/systemhealth/corporation/${cId}`;
    if (cId === -1) {
      url = '/systemhealth/all';
    } else if (cId) {
      if (cId < 0) {
        url = `/systemhealth/parentCorpId/${Math.abs(cId)}`;
      } else {
        url = `/systemhealth/corporation/${cId}`;
      }
    }

    const { data } = await apiClient({
      method: 'GET',
      url,
    });

    const shData = Object.freeze(data);

    const completedProfile = [];
    const incompletedProfile = [];

    const { alertsCategory } = initialState();

    const systemHealthData = shData.map((d) => {
      const { customer, deviceAC, alerts } = d;
      const newData = {
        id: deviceAC.id,
        ...d,
      };

      let firstAlert = null;
      let recentAlert = null;

      newData.customer.name = `${customer.firstName} ${customer.lastName}`;

      let hasPerformance = false;
      let hasFilter = false;
      let hasLeak = false;
      let hasDevice = false;

      alerts.forEach((alert) => {
        const { category, firstOccurred, lastOccurred } = alert;
        if (!recentAlert) {
          recentAlert = lastOccurred;
        } else if (recentAlert < lastOccurred) {
          recentAlert = lastOccurred;
        }
        if (!firstAlert) {
          firstAlert = firstOccurred;
        } else if (firstAlert > firstOccurred) {
          firstAlert = firstOccurred;
        }
        if (category === 'Performance') {
          hasPerformance = true;
        }
        if (category === 'Filter') {
          hasFilter = true;
        }
        if (category === 'Leak') {
          hasLeak = true;
        }
        if (category === 'Device') {
          hasDevice = true;
        }
      });
      if (deviceAC.profileCompletedDate) {
        if (hasPerformance) {
          alertsCategory.performance.count += 1;
        }
        if (hasFilter) {
          alertsCategory.filter.count += 1;
        }
        if (hasLeak) {
          alertsCategory.leak.count += 1;
        }
        if (hasDevice) {
          alertsCategory.device.count += 1;
        }
      }

      newData.firstAlert = firstAlert;
      newData.recentAlert = recentAlert;

      // Need new key everytime to avoid the previous state of vuetify table
      newData.key = Math.random() * 100000000;

      if (alerts.length === 0) {
        if (d.deviceAC.profileCompletedDate) {
          alertsCategory.noAlerts.count += 1;
        }
      }

      if (d.deviceAC.profileCompletedDate) {
        completedProfile.push(newData);
      } else {
        incompletedProfile.push(newData);
      }
      return newData;
    });

    iHaveEverything.set('all', {
      allSystemHealth: systemHealthData,
      completedProfile,
      incompletedProfile,
    });

    commit({
      type: SYSTEM_HEALTH_SET_SYSTEM_HEALTH,
      allSystemHealth: systemHealthData,
      completedProfile,
      incompletedProfile,
      alertsCategory,
      iHaveEverything,
      selectedCorp: cId,
    });
  },
  async setExpandableRow({ commit, state }, payload) {
    const { id, uid } = payload;

    const { systemHealthExpandableData } = state;

    commit({
      type: SYSTEM_HEALTH_RESET_SYSTEM_HEALTH_LOADER,
    });

    let expandableData;
    if (systemHealthExpandableData.has(id)) {
      expandableData = systemHealthExpandableData.get(id);
    } else {
      const { data } = await apiClient({
        method: 'GET',
        url: `/systemhealth/uid/${uid}`,
      });
      const chronic = await apiClient({
        method: 'GET',
        url: `/alerts/chronic/${uid}`,
      });
      const chronicAlerts = chronic.data;

      const {
        customer, deviceAC, alerts,
      } = data;

      const filters = [];

      deviceAC.filters.forEach((f, idx) => {
        const filterLifePercentage = filterLife(f);
        const filter = {
          ...f,
        };
        filter.index = idx + 1;
        if (filterLifePercentage === 'Calculating') {
          filter.filterLife = '100, 100';
          filter.filterLifePercentage = 'Calculating';
        } else if (filterLifePercentage) {
          filter.filterLife = `${filterLifePercentage}, 100`;
          filter.filterLifePercentage = `${parseInt(filterLifePercentage, 10)}%`;
        } else {
          filter.filterLife = '0, 100';
          filter.filterLifePercentage = '0%';
        }
        filters.push(filter);
      });

      const notifications = [];
      const alertCategory = {
        Performance: [],
        Filter: [],
        Leak: [],
        Device: [],
      };

      alerts.forEach((alert) => {
        const { category } = alert;
        if (alertCategory[category]) {
          alertCategory[category].push(alert);
        }
      });

      Object.keys(alertCategory).forEach((key) => {
        alertCategory[key].forEach((n, idx) => {
          const noti = {
            ...n,
          };
          noti.index = `${n.uid}-${n.did}-${n.type}-${n.timestamp}`;
          noti.category = key;
          if (idx === 0) {
            noti.startCategory = true;
          }
          if (idx === alertCategory[key].length - 1) {
            noti.endCategory = true;
          }
          notifications.push(noti);
        });
      });

      systemHealthExpandableData.set(id, {
        customer,
        hvac: deviceAC,
        filters,
        notifications,
        chronicAlerts,
      });

      expandableData = systemHealthExpandableData.get(id);
    }

    const {
      customer, hvac, filters, notifications, chronicAlerts,
    } = expandableData;

    commit({
      type: SYSTEM_HEALTH_SET_EXPANDABLE_ROW,
      customer,
      hvac,
      filters,
      notifications,
      chronicAlerts,
      currentExpandedRowId: id,
    });
  },
  async workPerformedAlerts({ commit }, payload) {
    const {
      date, technicianName, workPerformed, alerts,
    } = payload;

    const workDate = date.toISOString();

    const request = {};
    request.workRecord = {
      technicianName,
      workDate,
      workPerformed,
    };

    const performanceAlerts = alerts.filter((a) => a.category === 'Performance');

    // When work is performed, clear only performance alerts
    request.performanceAlerts = performanceAlerts.map((a) => {
      const newObj = {};
      newObj.uid = a.uid;
      newObj.did = a.did;
      newObj.type = a.type;
      newObj.boundaryMin = a.boundaryMin;
      newObj.boundaryMax = a.boundaryMax;

      return newObj;
    });

    await apiClient({
      method: 'PUT',
      url: 'alerts/performance/workperform/list',
      data: request,
    });

    commit({
      type: SYSTEM_HEALTH_SET_SYSTEM_HEALTH_AGAIN,
    });
  },
  async dismissAlerts({ commit, state }, payload) {
    const {
      alerts,
    } = payload;

    const {
      actionDismissReason, status, actionNote, unmuteDate,
    } = state;

    const dismissAlerts = alerts.map((a) => ({
      alertId: a.alertId,
      status,
      actionReason: actionDismissReason,
      note: actionNote,
      unmuteDate,
    }));
    await apiClient({
      method: 'PUT',
      url: 'alerts/action/perform',
      data: dismissAlerts,
    });

    commit({
      type: SYSTEM_HEALTH_SET_SYSTEM_HEALTH_AGAIN,
    });
  },
  async updateAlertsStatus({ commit }, payload) {
    const { alerts, status, allAlerts } = payload;

    const tempSet = new Set();

    const newAlerts = alerts.map((a) => {
      tempSet.add(a.index);
      const {
        index, startCategory, endCategory, ...alert
      } = a;
      return alert;
    });

    const newNotifications = allAlerts.map((a) => {
      const newNotiObj = _.cloneDeep(a);
      if (tempSet.has(a.index)) {
        newNotiObj.status = status;
      }
      return newNotiObj;
    });

    await apiClient({
      method: 'PUT',
      url: `alerts/update/status/${status}/list`,
      data: newAlerts,
    });

    commit({
      type: SYSTEM_HEALTH_SET_EXPANDABLE_ROW_AGAIN,
      newNotifications,
    });
  },
  resetExpandableRow({ commit }) {
    commit({
      type: SYSTEM_HEALTH_RESET_SYSTEM_HEALTH,
    });
  },
  async exportSystemHealthData({ commit, state }) {
    const {
      selectedCorp,
    } = state;
    commit({
      type: SYSTEM_HEALTH_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });
    try {
      const { data } = await apiClient({
        method: 'GET',
        url: `/systemhealth/corporation/${selectedCorp}/exportcsv`,
      });
      commit({
        type: SYSTEM_HEALTH_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      return data;
    } catch (err) {
      commit({
        type: SYSTEM_HEALTH_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      throw err;
    }
  },
  async exportHVACProfilesData({ commit, state }) {
    const {
      selectedCorp,
    } = state;
    commit({
      type: SYSTEM_HEALTH_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });
    try {
      const { data } = await apiClient({
        method: 'GET',
        url: `/devices/ac/export/${selectedCorp}`,
      });
      commit({
        type: SYSTEM_HEALTH_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      return data;
    } catch (err) {
      commit({
        type: SYSTEM_HEALTH_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      throw err;
    }
  },
};

export default actions;
